import useFetch from 'use-http';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import Link from './Link.js';

const TopRssArticleLink = () => {
  const { rssFeedUrl } = useSearchParamOrDefaultProps();

  const {
    loading,
    error,
    data: results,
  } = useFetch(rssFeedUrl, { retries: 3 }, []);

  const headlines = (results?.data && results.data[0].title) || '';
  const to = (results?.data && results.data[0].link) || '';

  return (
    <>
      {error && ''}
      {loading && ''}
      {headlines && (
        <Link to={to} styleAsButton={false}>
          {headlines}
        </Link>
      )}
    </>
  );
};

TopRssArticleLink.displayName = 'TopRssArticleLink';

export default TopRssArticleLink;
